export const subscriptionMutations = {
  setAllSubscriptions(state, payload) {
    state.allSubscriptions = payload;
  },
  setSelectedSubscription(state, payload) {
    state.selectedSubscription = payload;
  },
  setSubscriptionForm(state, payload) {
    state.subscriptionForm = payload;
  },
};
